import axios from "axios";

export const getExpenseTypeNames = async () => {
    return (await axios.get<string[]>("/docks/expense/expenseTypeNames")).data;
};
